export const MODEL_EXPENSE_AGENCY_CLIENT = "agency_client"
export const MODEL_EXPENSE_AGENCY_MODEL = "agency_model"
export const MODEL_EXPENSE_MODEL_CLIENT = "model_client"
export const EXPENSE_PAID_AGENCY = "paid_agency"
export const EXPENSE_PAID_SCOUTER = "paid_scouter"
